import {
  Anchor,
  Bath,
  Dices,
  Dog,
  Fish,
  Flame,
  Gamepad2,
  MoveHorizontal,
  PartyPopper,
  Plug,
  Target,
  Trees,
  Tv,
  Users,
  WashingMachine,
  Wifi,
  type LucideIcon,
} from "lucide-react";
import { MaskReveal, Reveal } from "../Reveal";
import { PHOTO_SIZES, PHOTOS } from "../images";

const AMENITIES: { icon: LucideIcon; label: string; wide?: boolean }[] = [
  { icon: Bath, label: "Full RV Hookups", wide: true },
  { icon: Plug, label: "30- and 50-Amp Service", wide: true },
  { icon: Wifi, label: "Wi-Fi" },
  { icon: Tv, label: "Cable Television" },
  { icon: WashingMachine, label: "Onsite Laundry" },
  { icon: Dog, label: "Off-Leash Pet Area" },
  { icon: Users, label: "Clubhouse" },
  { icon: Gamepad2, label: "Game Room" },
  { icon: MoveHorizontal, label: "Shuffleboard" },
  { icon: Dices, label: "Poker Table" },
  { icon: Target, label: "Dartboard" },
  { icon: Trees, label: "Covered Picnic Area" },
  { icon: Flame, label: "Barbecue Pits" },
  { icon: Anchor, label: "Nearby Public Boat Access" },
  { icon: Fish, label: "Fishing Near Falcon Lake" },
  { icon: PartyPopper, label: "Meeting and Gathering Space", wide: true },
];

export function RoomsAmenities() {
  const photo = PHOTOS.clubhouse;

  return (
    <section
      className="bg-forest-deep py-24 text-cream sm:py-28 lg:py-32"
      aria-labelledby="rooms-amenities-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:items-end lg:gap-20">
          <Reveal>
            <p className="eyebrow text-sand">Park Amenities</p>
            <h2
              id="rooms-amenities-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Comforts That Make Longer Stays Easy
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-cream/80">
              From full hookups and laundry to gathering spaces and a pet area, Amigo Inn is set up
              for weekend visits and extended South Texas stays alike.
            </p>
          </Reveal>

          <MaskReveal className="media-zoom rounded-sm">
            <img
              src={photo.src}
              srcSet={photo.srcSet}
              sizes={PHOTO_SIZES.half}
              alt={photo.alt}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="aspect-[16/9] w-full rounded-sm object-cover"
            />
          </MaskReveal>
        </div>

        <ul className="mt-16 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {AMENITIES.map((item, i) => (
            <Reveal
              as="li"
              key={item.label}
              delay={(i % 4) * 0.04}
              {...(item.wide ? { className: "sm:col-span-2 lg:col-span-2" } : {})}
            >
              <div
                className={
                  item.wide
                    ? "flex h-full min-h-[88px] items-center gap-4 border border-cream/15 bg-cream/5 px-5 py-5"
                    : "flex h-full min-h-[88px] items-center gap-4 border-b border-cream/15 px-1 py-5"
                }
              >
                <item.icon className="size-5 shrink-0 text-sand" aria-hidden="true" />
                <span className="text-sm font-medium leading-snug text-cream/95">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
